module.exports = __webpack_public_path__ + "static/media/18ECA8.4a38b46e.jpg";